import { render, staticRenderFns } from "./BodyTemperatureComponent.vue?vue&type=template&id=1b69583f"
import script from "./BodyTemperatureComponent.vue?vue&type=script&lang=js"
export * from "./BodyTemperatureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports